import React, { useEffect, useState } from 'react';
import { Bar, BarConfig, Column, ColumnConfig, Line, LineConfig } from '@ant-design/charts';
import moment from 'moment-jalaali';
import { Button, Col, notification, Row, Segmented, Spin } from 'antd';
import restful from '../../restful';

const RequestsChart: React.FC = () => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [data, setData] = useState<any>([]);
  const [client, setClient] = useState<string | number>('app')

  const fetchData = () => {
    setIsLoaded(true);
    restful.get(`/request-logs/chart?client=${client}`)
      .then((res) => {
        setData(res.data.result.columns);
      })
      .catch((error) => {
        return notification.error({
          message: 'Error ' + error.statusCode,
          description: error.message,
        });
      })
      .finally(() => { setIsLoaded(false) })
  };

  useEffect(() => { fetchData(); }, [client])


  const today = moment()

  const config: ColumnConfig = {
    data,
    xField: 'date',
    yField: 'request',
  };

  return (
    <Spin spinning={isLoaded}>
      <Row gutter={[16, 16]} style={{ padding: "16px 0" }}>
        <Col flex="auto" >
          <Segmented options={['admin', 'app', "other"]} value={client} onChange={setClient} />
        </Col>
        <Col flex="none"><Button onClick={() => fetchData()} >تازه سازی</Button></Col>
      </Row>

      <Column {...config} />
    </Spin>
  );
};

export default RequestsChart;